export default {
  // getStatus (state) {
  //   return state.is_open
  // },
  // getMessageList (state) {
  //   return state.messageList
  // },
  // getParticipants (state) {
  //   return state.participants
  // }

  getWindownChats (state) {
    var windownOpen = []
    state.windown_chats.forEach(element => {
      if (element.is_open) {
        windownOpen.push(element)
      }
    })
    return windownOpen
  }
}



// WEBPACK FOOTER //
// ./src/store/module/chat/getters.js